module.exports=function(scope){ return `let licenseKeyIdentifier = "<THIS_IDENTIFIER_WILL_DEPEND_ON_YOUR_DEVELOPER_ACCOUNT>"

// Key text is an extra required paramter for SFTP Log mode only.
// If copied from a Key file, make sure Key text is a single string with newLine ('\\n') characters where appropriate.
// 'appId' should match your application's unique bundle identifier.
//
let licenseText = "appId = <THIS_APPID(s)_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n" +
                      "expiryDate = <THIS_DATE_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n" +
                      "key = <THIS_KEY_WILL_DEPEND_ON_YOUR_SPECIFIC_LICENSE>\\n"


// Initialize the FaceTec SDK with your SDK Key
// @param - licenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - initializationSuccessful -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
Zoom.sdk.initialize(
    licenseKeyIdentifier: licenseKeyIdentifier,
    completion:
    {
      initializationSuccessful in
          if(!initializationSuccessful) {
            handleUnsuccessfulInit()
            return
          }

          // Ready to launch the User Session!
    }
)


// Initialize ZoomSDK using a Device SDK Key - SFTP Log mode
// @param - licenseText - This is the contents of the actual Key file that FaceTec generated for you. Your Key (s) can be downloaded here -- https://dev.facetec.com/zoomsdk/#/account
// @param - licenseKeyIdentifier - This is your Device SDK Key Identifier. You can get your Device SDK Key Identifier here: https://dev.facetec.com/zoomsdk/#/account
// @param - initializationSuccessful -  Optional callback to notify caller when FaceTec SDK initialization has completed
//
Zoom.sdk.initialize(
    licenseText: licenseText,
    licenseKeyIdentifier: licenseKeyIdentifier,
    completion:
    {
      initializationSuccessful in
          if (!initializationSuccessful) {
            handleUnsuccessfulInit()
            return
          }

          // Ready to launch the User Session!
    }
)
`};


// WEBPACK FOOTER //
// ./src/resources/code/quickstart/ios/00-initialize.swift.tpl